import Vue from 'vue'
import axios from 'axios'
import Qs from "qs"
import {
  Message
} from 'element-ui'

// create an axios instance

// axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8"
const service = axios.create({
  baseURL: Vue.prototype.BASE_URL, // url = base url + request url
  timeout: 60000, // request timeout
  headers: {
    //公共请求头配置，本项目请求头大多数接口是这个，所以这里可以配置一下，对于特殊接口单独配置
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
  },
  transformRequest: [data => Qs.stringify(data, { indices: true })]
})
service.defaults.withCredentials = true // 跨域
// request interceptor
service.interceptors.request.use(
  config => {
    config.baseURL = Vue.prototype.BASE_URL
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  res => {
    if (res.headers['content-type'] === 'image/jpeg') {
      return Promise.resolve(res.data)
    }
    switch (parseInt(res.data.code)) {
      case 10000:
        if (res.data.data) {
          return Promise.resolve(res.data)
        } else {
          return Promise.resolve(res.data)
        }
    case 10001:
        alert(res.data.message || '网络卡住了，请刷新')
        break;
    default:
        alert(res.data.message || '网络卡住了，请刷新')

        // return Promise.reject(res.data)
    }
  },
  error => {
    Message.closeAll()
    if (!error.response) {
      Message({
        message: '网络卡住了，请刷新',
        type: 'error'
      })
    }
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
      Message({
        message: '网络卡住了，请刷新',
        type: 'error'
      })
    }
    return Promise.reject(error)
  }
)

export function $get(url, params = {}) {
  return service.get(url, {
    params
  })
}
export function $post(url, data = {}) {
  return service.post(url, data)
}

export default service
